import { serializable, alias, object, list, primitive } from "serializr";
import { Branches } from "./branches.model";
import { Institutes } from "./institutes.model";

class Section {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoomId?: number;
}
class ClassRoom {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;
}

class Board {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("acronym", primitive()))
  acronym?: string;

  @serializable(alias("name", primitive()))
  name?: string;
}
export class Parent {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("email", primitive()))
  email?: string;
}

export class Students {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("first_name", primitive()))
  name?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("roll_number", primitive()))
  rollNumber?: string;

  @serializable(alias("board", object(Board)))
  board?: Board;

  @serializable(alias("institute", object(Institutes)))
  institute?: Institutes;

  @serializable(alias("branch", object(Branches)))
  branch?: Branches;

  @serializable(alias("class_room", object(ClassRoom)))
  classRoom?: ClassRoom;

  @serializable(alias("section", object(Section)))
  section?: Section;

  // @serializable(alias("parent", object(Parent)))
  // parent?: Parent;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("blocked_reason", primitive()))
  blockedReason?: string;
}

export class StudentCreateModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("firstName", primitive()))
  firstName?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("startDate", primitive()))
  startDate?: string;

  @serializable(alias("endDate", primitive()))
  endDate?: string;

  @serializable(alias("rollNumber", primitive()))
  rollNumber?: string;

  @serializable(alias("sectionId", primitive()))
  sectionId?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phoneNumber", primitive()))
  phoneNumber?: string;

  @serializable(alias("isBlocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("password", primitive()))
  password?: string;

  @serializable(alias("courseId", primitive()))
  courseId?: number;
}

export class FilterStudent {
  @serializable(alias('sectionId', primitive()))
  section_id?: number;

  @serializable(alias('classRoomId', primitive()))
  branch_class_room_id?: number;

  @serializable(alias('branchId', primitive()))
  branch_id?: number;

  @serializable(alias('institute_id', primitive()))
  institute_id?: number;

  @serializable(alias('search', primitive()))
  search?: string;

  @serializable(alias('page', primitive()))
  page?: number;

  @serializable(alias('perpage', primitive()))
  perpage?: number;

  @serializable(alias('isActive', primitive()))
  is_active?: boolean;
}

export class StudentMetaModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("first_name", primitive()))
  name?: string;

  @serializable(alias("email", primitive()))
  email?: string;
}
